import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { MdOutlineClose, MdWarning } from 'react-icons/md';
import { useDispatch } from 'react-redux';

// Component import
import { Button } from '@components/Button';

// Hook import
import { useTranslation } from '@hooks/useTranslation';

// Service import
import { api } from '@services/api';

// Store import
import { setBagSummary, setBagId } from '@store/modules/ui/actions';

import { Container } from './styles';

// Util import

// Interfaces
interface IProps {
  hide?: () => any;
  cartId: string;
  setActiveModal: React.Dispatch<React.SetStateAction<boolean>>;
}

// Feature identification
const featureKey = '@saved_bags/SAVED_BAGS_MODAL';

const DeleteUniqueBagModal: React.FC<IProps> = ({
  hide,
  cartId,
  setActiveModal,
  // setLoading,
}) => {
  // Hooks
  const { t } = useTranslation(featureKey);
  const dispatch = useDispatch();

  const deleteBag = useCallback(async () => {
    try {
      // API call
      await api.delete(`/v1/cart/${cartId}`);
    } catch (err: any) {
      toast.error(t('DELETE_ERROR', 'Erro ao deletar sacola'));
    }

    setActiveModal(false);
    dispatch(setBagSummary(false));
    dispatch(setBagId('update'));

    if (typeof hide === 'function') hide();
  }, [cartId, dispatch, hide, setActiveModal, t]);

  return (
    <Container>
      <div className="closeRow">
        <button
          type="button"
          onClick={() => {
            // Hide modal
            if (typeof hide === 'function') hide();
          }}
        >
          <MdOutlineClose className="closeIcon" />
        </button>
      </div>
      <div className="iconRow">
        <MdWarning />
      </div>
      <div className="textRow">
        <p className="text">
          {t('DELETE_BAG_ASK', 'Deseja excluir a sacola salva?')}
        </p>
        <p className="addtionalTextRow">
          {t('ADDITIONAL_INFO', 'Esta ação não poderá ser desfeita.')}
        </p>
      </div>

      <div className="actionArea">
        <Button
          variant="outlined"
          color="danger"
          onClick={() => {
            // Hide modal
            if (typeof hide === 'function') hide();
          }}
        >
          {t('NO', 'NÃO')}
        </Button>
        <Button
          onClick={async () => {
            await deleteBag();
          }}
        >
          {t('YES', 'SIM')}
        </Button>
      </div>
    </Container>
  );
};

export { DeleteUniqueBagModal };
